// ponytail: mismo patrón que lanzo-social-proof.js — custom element, setTimeout
// re-agendado y sessionStorage en try/catch.
function lanzoUrgenciaRand(min, max) {
  const lo = Math.max(1, Math.floor(min));
  const hi = Math.max(lo, Math.floor(max));
  return lo + Math.floor(Math.random() * (hi - lo + 1));
}

// Un tick: baja 1 disponible hasta el piso, sube 1 vendida. Sin piso el bloque
// terminaría anunciando "0 unidades disponibles" con el botón de compra activo.
function lanzoUrgenciaTick(state) {
  return {
    units: Math.max(state.units - 1, state.min),
    sold: state.sold + 1,
    min: state.min,
  };
}

// El contador vive dentro de una ventana de tiempo (default 60 min, que es lo que
// promete el copy "vendidas en la última hora"). Dentro de la ventana acumula; al
// agotarse se congela, y la siguiente visita arranca una base nueva. Eso corta los
// dos problemas: el "675 vendidas" de una pestaña abierta media tarde, y el visitante
// que revisa el producto tres veces y ve el número que él mismo dejó subiendo.
function lanzoUrgenciaBase(saved, cfg, now) {
  if (saved.t0 && now - saved.t0 < cfg.windowMs) {
    return {
      t0: saved.t0,
      min: cfg.min,
      // un valor guardado fuera de rango se corrige en vez de confiarse
      units: Math.min(Math.max(saved.units ?? cfg.start, cfg.min), cfg.start),
      sold: Math.max(saved.sold ?? cfg.sold, cfg.sold),
    };
  }
  // Base nueva y aleatoria dentro del rango del merchant: si reiniciara siempre a
  // los mismos números, el que vuelve al rato nota el reinicio de una.
  return {
    t0: now,
    min: cfg.min,
    units: lanzoUrgenciaRand(cfg.min, cfg.start),
    sold: cfg.sold + lanzoUrgenciaRand(0, cfg.jitter),
  };
}

class LanzoUrgencia extends HTMLElement {
  connectedCallback() {
    this.unitsEl = this.querySelector('[data-lanzo-units]');
    this.soldEl = this.querySelector('[data-lanzo-sold]');
    if (!this.unitsEl || !this.soldEl) return;

    const start = parseInt(this.dataset.units, 10) || 0;
    const cfg = {
      start,
      min: Math.min(parseInt(this.dataset.min, 10) || 0, start),
      sold: parseInt(this.dataset.sold, 10) || 0,
      jitter: Math.max(parseInt(this.dataset.jitter, 10) || 0, 0),
      windowMs: (parseInt(this.dataset.windowMin, 10) || 60) * 60000,
    };

    this.state = lanzoUrgenciaBase(this.restore(), cfg, Date.now());
    this.deadline = this.state.t0 + cfg.windowMs;

    this.paint();
    this.save();
    this.schedule();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  paint() {
    this.unitsEl.textContent = this.state.units;
    this.soldEl.textContent = this.state.sold;
  }

  schedule() {
    // Ventana agotada: se congela en silencio. Reiniciar con la página a la vista
    // sería justo lo visible que no queremos.
    if (Date.now() >= this.deadline) return;
    const delay = lanzoUrgenciaRand(this.dataset.minS, this.dataset.maxS) * 1000;
    this.timer = setTimeout(() => {
      this.state = { ...this.state, ...lanzoUrgenciaTick(this.state) };
      this.paint();
      this.save();
      this.schedule();
    }, delay);
  }

  restore() {
    try {
      return JSON.parse(sessionStorage.getItem(this.dataset.key)) || {};
    } catch (e) {
      return {};
    }
  }

  save() {
    try {
      sessionStorage.setItem(
        this.dataset.key,
        JSON.stringify({ t0: this.state.t0, units: this.state.units, sold: this.state.sold })
      );
    } catch (e) {
      /* almacenamiento no disponible: sigue funcionando en memoria */
    }
  }
}

customElements.define('lanzo-urgencia', LanzoUrgencia);
